import {
  humanizeKey,
  isPlainObject,
  pickSectionPayload,
  sanitizeObject,
  sanitizeReferences,
  HIDDEN_KEYS,
} from "./analysisUtils";
import JsonRenderer from "./JsonRenderer";

function KeyValueGrid({ value }) {
  if (!isPlainObject(value)) {
    return <JsonRenderer value={value} />;
  }
  const entries = Object.entries(sanitizeObject(value, HIDDEN_KEYS));
  if (entries.length === 0) {
    return <span className="text-base-content/60">—</span>;
  }
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {entries.map(([k, v]) => (
        <div
          key={k}
          className="rounded-lg border border-base-300 bg-base-100 p-3"
        >
          <div className="text-sm font-semibold text-primary">{humanizeKey(k)}</div>
          <div className="mt-1 text-sm">
            <JsonRenderer value={v} depth={1} />
          </div>
        </div>
      ))}
    </div>
  );
}

const SectionCard = ({ sectionKey, sectionValue, refLimit }) => {
  const { response, pmid, references } = pickSectionPayload(sectionValue);
  const responseToRender = sanitizeObject(response, HIDDEN_KEYS);
  const referencesToRender = references
    ? sanitizeReferences(references, refLimit)
    : undefined;

  return (
    <div className="card border border-base-300 bg-base-100 shadow-sm">
      <div className="card-body p-4">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h3 className="text-lg font-bold text-base-content">
            {humanizeKey(sectionKey)}
          </h3>
          {pmid && (
            <span className="badge badge-neutral">PMID: {pmid}</span>
          )}
        </div>
        <div className="mt-3">
          <KeyValueGrid value={responseToRender} />
        </div>
        {referencesToRender && (
          <div className="mt-4">
            <details className="collapse collapse-arrow border border-base-300 bg-base-200">
              <summary className="collapse-title font-semibold text-primary">
                Top Referenced Literature ({Array.isArray(referencesToRender) ? referencesToRender.length : 1})
              </summary>
              <div className="collapse-content bg-base-100">
                <div className="space-y-3 pt-2">
                  {Array.isArray(referencesToRender) ? (
                    referencesToRender.map((ref, idx) => (
                      <div
                        key={idx}
                        className="rounded-lg border border-base-300 bg-base-100 p-3 text-sm"
                      >
                        <KeyValueGrid value={ref} />
                      </div>
                    ))
                  ) : (
                    <KeyValueGrid value={referencesToRender} />
                  )}
                </div>
              </div>
            </details>
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionCard;
